import React from 'react';
import { Accordion } from './ui/Accordion';
import { Settings } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Es un pago mensual o único?',
    a: 'Es un único pago. No hay suscripciones ni cobros ocultos. Pagás una vez y te queda para siempre.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con el enlace para descargar todo el kit en tu computadora o celular.'
  }, {
    q: '¿Sirve para clínicas pequeñas o solo grandes hospitales?',
    a: 'Está diseñado para ser 100% escalable. Sirve tanto para un consultorio con 5 empleados como para un sanatorio con 500.'
  }, {
    q: '¿Está adaptado a las leyes de Argentina?',
    a: 'Sí, todas las planillas, especialmente el liquidador de adicionales y el control de matrículas, están pensadas para el sistema de salud argentino.'
  }, {
    q: '¿Necesito programas especiales para abrirlo?',
    a: 'No. Solo necesitás un lector de PDF y Excel (o Google Sheets) que son gratuitos y vienen en casi cualquier computadora.'
  }];
  return <section className="py-12 px-4" data-id="element-62">
      <div className="max-w-lg mx-auto" data-id="element-63">
        <h2 className="text-2xl font-bold text-center text-white mb-8 drop-shadow-lg" data-id="element-64">
          Preguntas Frecuentes
        </h2>

        <div className="mb-12" data-id="element-65">
          {faqs.map((faq, idx) => <Accordion key={idx} title={faq.q} data-id="element-66">
              <p data-id="element-67">{faq.a}</p>
            </Accordion>)}
        </div>

        <div className="text-center bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg" data-id="element-68">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-slate-100 rounded-full mb-4" data-id="element-69">
            <Settings className="w-6 h-6 text-slate-600" data-id="element-70" />
          </div>
          <p className="text-slate-600 font-medium mb-1" data-id="element-71">¿Necesitás ayuda?</p>
          <a href="mailto:EbookDreamShop@gmail.com" className="text-teal-600 font-bold hover:underline" data-id="element-72">
            EbookDreamShop@gmail.com
          </a>
        </div>
      </div>
    </section>;
}